import { ImpactModule } from 'types'
import { INSTITUTIONAL_MANAGEMENT_PAGES } from './pages'
import { INSTITUTIONAL_MANAGEMENT_PAGES_ORDER_FOR_PERMISSIONS } from './pagesOrderForPermissions'

export const INSTITUTIONAL_MANAGEMENT_MODULE: ImpactModule = {
  NAME: 'admin',
  NAME_PTBR: 'Gestão Institucional',
  UPPER_NAME: 'ADMIN',
  API_NAME: 'ADMIN',
  PAGES: INSTITUTIONAL_MANAGEMENT_PAGES,
  PAGES_ORDER_FOR_PERMISSIONS: INSTITUTIONAL_MANAGEMENT_PAGES_ORDER_FOR_PERMISSIONS,
}
